import {
  accountsService,
  pingTreeService,
  utilities,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

export class AvailablePingTreesViewModel {

  /** @type {{ type: 'new-ping-tree-route', target }} */
  modal = null;

  /** @type {import('./RoutingPlansViewModel').RoutingPlansViewModel} */
  context = null;

  isLoading = false;
  isRefreshingPingTrees = false;

  pingTrees = [];
  hasAnyItem = false;

  initialize(ctx) {
    this.context = ctx;

    this._loadPingTrees(false);

    return this;
  }

  closeModal = () => {
    this.modal = null;
  };

  openNewPingTreeRouteModal = (target) => {
    this.modal = { type: 'new-ping-tree-route', target };
  };

  refreshPingTrees = () => {
    this.isRefreshingPingTrees = true;
    try {
      this._loadPingTrees();
    } finally {
      setTimeout(() => {
        this.isRefreshingPingTrees = false;
      }, 600);
    }
  };

  async _loadPingTrees(silent = true) {
    if (!silent) {
      this.isLoading = true;
    }

    try {
      const response = await pingTreeService.getPingTrees(accountsService.currentAccountId, true);
      /** @type {any[]} */
      const items = response?.data?.pingTrees || [];
      this.hasAnyItem = items.length > 0;

      // this.pingTrees = $filter('notInCampaignRoutes')(response.data.pingTrees, vm.routeContainerRoutes, 'pingTree')
      this.pingTrees = this.context.routeContainer?.routes
        ? items.filter(target => this.context.routeContainer.routes.every(route => route.callPingTree?.id !== target.id))
        : items;

    } catch (error) {
      console.error('_loadPingTrees ERROR:', error);
      utilities.errorHandler(error);
    } finally {
      this.isLoading = false;
    }

  }
}
